import React, { memo, useState } from "react";

interface TooltipProps {
  /**
   * Where you want to display the tooltip
   */
  children: string | React.ReactNode;

  /**
   * Position of tooltip display
   * @default top
   */
  position?: "top" | "right" | "left" | "bottom" | "topLeft" | "topRight";

  /**
   * Max width of tooltip
   */
  maxWidth?: string;

  /**
   * What you want to show in tooltip
   */
  content: string | React.ReactNode;
  /**
   * Hotkey value for your tooltip
   */
  hotKey?: string;
  /**
   * Custom styling tooltip
   */
  styles?: Record<string, unknown>;
  getPopupContainer?: () => HTMLElement;
  onOpenChange?: (open: boolean) => void;
}

const Tooltip = memo(function Tooltip(props: TooltipProps) {
  const [open, setOpen] = useState(false);

  const getPlacementClass = () => {
    switch (props.position) {
      case "right":
        return "mw-tooltip-right";
      case "left":
        return "mw-tooltip-left";
      case "bottom":
        return "mw-tooltip-bottom";
      case "topLeft":
        return "mw-tooltip-top-left";
      case "topRight":
        return "mw-tooltip-top-right";
      default:
        return "mw-tooltip-top";
    }
  };

  const hotKeyContent = (
    <div className="hotkey-container">
      <span className="hotkey-content">{props.content}</span>
      <span className="hotkey-overlay">{props.hotKey}</span>
    </div>
  );

  return (
    <span
      className="mw-tooltip-wrapper"
      onMouseEnter={() => {
        setOpen(true);
        props.onOpenChange?.(true);
      }}
      onMouseLeave={() => {
        setOpen(false);
        props.onOpenChange?.(false);
      }}
      onFocus={() => {
        setOpen(true);
        props.onOpenChange?.(true);
      }}
      onBlur={() => {
        setOpen(false);
        props.onOpenChange?.(false);
      }}
    >
      {props.children}
      {open && (
        <span
          className={`mw-tooltip-overlay ${getPlacementClass()}`}
          style={{
            maxWidth: props.maxWidth ? props.maxWidth : "calc(100vw - 100px)",
            ...(props.styles || {}),
          }}
          role="tooltip"
        >
          {props.hotKey ? hotKeyContent : props.content}
        </span>
      )}
    </span>
  );
});

export default Tooltip;
